var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"mt-3 elevation-0"},[_c('v-card-title',[_c('h5',[_vm._v("Clientes")])]),_c('v-card-text',{staticClass:"pa-2"},[_c('highcharts',{attrs:{"options":_vm.chartOptions,"deepCopyOnUpdate":false}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }